import { render } from "./ViewJamakkol.vue?vue&type=template&id=2616c7a9&scoped=true"
import script from "./ViewJamakkol.vue?vue&type=script&lang=js"
export * from "./ViewJamakkol.vue?vue&type=script&lang=js"

import "./ViewJamakkol.vue?vue&type=style&index=0&id=2616c7a9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2616c7a9"]])

export default __exports__